import { all, call, put, takeLatest } from 'redux-saga/effects';
import { customerOperations, customerTypes } from '../../store/customer';
import {
  getAdditionalCustomer,
  updateAdditionalCustomer,
} from '../../api/customer';

import { DAS_UPDATE_ADDITIONAL_CUSTOMER_FAILED } from '../../constants/errors';
import constants from '../../constants';
import { createError } from '../../store/errors';
import { getBookings } from '../../store/bookings/actions';
import { goToRoute } from '../../lib/router';
import { messageOperations } from '../../store/messages';
import { performGetBookingRequiredData } from '../booking/getBookingRequiredData';

const { UPDATE_ADDITIONAL_CUSTOMER } = customerTypes;

/* eslint-disable max-statements */

export const performUpdateAdditionalCustomer = function* performUpdateAdditionalCustomer({
  payload,
}) {
  const { customerId, bookingRef, fields, redirectPath } = payload;

  const {
    getAdditionalCustomerFailed,
    getAdditionalCustomerSuccess,
    updateAdditionalCustomerSuccess,
  } = customerOperations;

  const { sendMessage } = messageOperations;

  try {
    const data = yield call(updateAdditionalCustomer, customerId, fields);
    if (data.errors) {
      // Handle web service errors.
      yield all(
        data.errors.map(error =>
          put(
            sendMessage({
              type: 'danger',
              displayType: 'toast',
              message: error.message,
            }),
          ),
        ),
      );
      return;
    }

    yield put(updateAdditionalCustomerSuccess(customerId));
    yield put(getBookings());

    // Reload the updated customer
    const { customer, errors } = yield call(getAdditionalCustomer, customerId);
    if (errors) {
      // Handle web service errors.
      yield all(errors.map(error => put(createError(error))));
      yield put(getAdditionalCustomerFailed(customerId));
      return;
    }

    if (customer) {
      yield put(getAdditionalCustomerSuccess(customer));
      yield call(performGetBookingRequiredData, {
        payload: { booking_ref: bookingRef },
      });
      yield put(
        sendMessage({
          type: 'success',
          displayType: 'toast',
          message: constants.UPDATE_ADDITIONAL_CUSTOMER_SUCCESS,
        }),
      );
    }

    if (redirectPath) {
      yield put(goToRoute(redirectPath));
    }
  } catch (error) {
    // Handle errors with the request itself, produce default error.
    yield put(
      createError({
        code: DAS_UPDATE_ADDITIONAL_CUSTOMER_FAILED,
      }),
    );
  }
};

export default takeLatest(
  UPDATE_ADDITIONAL_CUSTOMER,
  performUpdateAdditionalCustomer,
);
